function Alert(props) {
  const { msg } = props;
  return (
    <div className="inline-block w-4/5 p-1 pl-3 pr-3 text-sm text-white bg-red-700 border border-white rounded-lg" role="alert">
      <div className="flex flex-col items-start">
        <p className="font-bold">Uh oh</p>
        <p className="text-sm">{msg}</p>
      </div>
    </div>

  );
}

export default Alert;
